import { type IEvent } from '@solink/vd-data-layer/api-clients/platform/platform';
import settings from '@solinkcorp/settings';

/**
 * API for interacting with the events-api.
 */
export class EventsApi {
  /**
   * Edit event using the ingestion pipeline.
   * This should only be used to react to user actions.
   * Abusing this will affect the performance of the ingestion pipeline.
   */
  async editEvent(
    jwt: string,
    customerId: string,
    eventId: string,
    data: Partial<IEvent>,
    runAsync: boolean = true,
  ): Promise<IEvent> {
    const payload = {
      customerId,
      id: eventId,
      ...data,
    };
    const response = await fetch(`${settings.events}/${customerId}/events?runAsync=${runAsync}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${jwt}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`Failed to edit event: ${response.status}`);
    }

    return await response.json();
  }

  async createTestEvent(
    jwt: string,
    payload: Record<string, unknown>,
    ingest = true,
  ): Promise<unknown> {
    const response = await fetch(`${settings.events}/testEvent${ingest ? '?ingest=true' : ''}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${jwt}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const body = await response.text().catch(() => '');
      throw new Error(`${response.status} ${response.statusText}${body ? `: ${body}` : ''}`);
    }

    return await response.json();
  }
}

export default new EventsApi();
